import type { TooltipRefProps } from 'react-tooltip'

export const openTooltipWhenReady = (
    anchorSelector: string,
    tooltipRef: React.RefObject<null | TooltipRefProps>,
    onOpen?: () => void,
): void => {
    const openTooltip = () => {
        const anchorElement = document.querySelector(anchorSelector)

        if (anchorElement && tooltipRef.current) {
            tooltipRef.current.open({
                anchorSelect: anchorSelector,
            })
            onOpen?.()
        } else {
            requestAnimationFrame(openTooltip)
        }
    }

    requestAnimationFrame(() => {
        requestAnimationFrame(openTooltip)
    })
}
